module.exports = __webpack_public_path__ + "static/img/column_img_1-2.41c6487d.png";